import React from 'react'
import PropTypes from 'prop-types'

import Reply from './Reply'
import Twitter from './Twitter'
import Facebook from './Facebook'

class ReplyForm extends React.Component {
  static propTypes = {
    draft: PropTypes.object.isRequired,
  }

  render() {
    const { isTwitterTicket, isFacebookTicket } = this.props

    if (isTwitterTicket) return <Twitter {...this.props} />
    if (isFacebookTicket) return <Facebook {...this.props} />

    return <Reply {...this.props} />
  }
}

export default ReplyForm
